import { mimeForAudioPath } from './itemAudio';
import { mimeForVideoPath } from './itemVideo';

const AUDIO_EXTENSIONS = new Set(['mp3', 'm4a', 'wav', 'ogg', 'aac', 'flac']);

export function mediaExtension(filename: string): string {
  return filename.split('.').pop()?.toLowerCase() ?? '';
}

/** True when the attachment should use an HTML audio element (not video). */
export function isAudioAttachmentFilename(filename: string): boolean {
  return AUDIO_EXTENSIONS.has(mediaExtension(filename));
}

/** ISO BMFF (MP4/MOV/M4V): box size then "ftyp" at bytes 4–7. */
export function isLikelyVideoContainerBytes(bytes: Uint8Array): boolean {
  if (bytes.length < 8) return false;
  return bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 && bytes[7] === 0x70;
}

/** Detect MP3 at file start only (never scan MP4 binary for false frame-sync matches). */
export function isMp3Bytes(bytes: Uint8Array): boolean {
  if (isLikelyVideoContainerBytes(bytes)) return false;
  if (bytes.length >= 3 && bytes[0] === 0x49 && bytes[1] === 0x44 && bytes[2] === 0x33) return true;
  if (bytes.length >= 2 && bytes[0] === 0xff && (bytes[1]! & 0xe0) === 0xe0) return true;
  return false;
}

export function shouldUseAudioPlayback(filename: string, bytes?: Uint8Array): boolean {
  if (isAudioAttachmentFilename(filename)) return true;
  if (bytes && bytes.length > 0 && isMp3Bytes(bytes)) return true;
  return false;
}

export function mimeForMediaPlaybackPath(repoPath: string, bytes?: Uint8Array): string {
  const filename = repoPath.split('/').pop() ?? '';
  return shouldUseAudioPlayback(filename, bytes)
    ? mimeForAudioPath(repoPath.replace(/\.(mp4|webm|mov)$/i, '.mp3'))
    : mimeForVideoPath(repoPath);
}
